import React, { useState } from "react";
import {
    TextField,
    Button,
    CircularProgress,
    FormControl,
    InputLabel,
    Select,
    MenuItem, Card, CardHeader, Typography, CardContent, useTheme,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { setSuccess } from "../../../../Redux/AlertReducer";
import { useDispatch } from "react-redux";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";

export const ShowPin = ({ data, setData }) => {
  const { id } = useParams();
    const theme = useTheme();

  return (
      <div style={{display:"flex",justifyContent:"space-around",flexWrap: "wrap",  // Allow wrapping
        gap: "16px",       // Consistent spacing
        padding: "16px"}}>
        <Card
            sx={{
              minWidth: 300,
              maxWidth: 400,
              m: 2,
              borderRadius: 4,
              boxShadow: "0px 8px 24px rgba(149, 157, 165, 0.2)",
              transition: "transform 0.2s",
              "&:hover": { transform: "translateY(-4px)" },
            }}
        >
          <CardHeader
              title={
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Statistics Types
                </Typography>
              }
              sx={{
                bgcolor: theme.palette.primary.light,
                py: 1,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
              }}
          />
          <CardContent sx={{ bgcolor: "#f8f9fa", minHeight: 200 }}>

            <div key={'view'} className="row" style={{ padding: '8px 0',display:'flex',justifyContent:"space-evenly" }}>
              <div>
                Views
              </div> :
              <div >
                {data.views}
              </div>
            </div>

            <div key={'click'} className="row" style={{ padding: '8px 0',display:'flex',justifyContent:"space-evenly" }}>
              <div>
                Clicks
              </div> :
              <div >
                {data.clicks}
              </div>
            </div>

          </CardContent>
        </Card>
        <Card
            sx={{
              minWidth: 300,
              maxWidth: 500,
              m: 2,
              borderRadius: 4,
              boxShadow: "0px 8px 24px rgba(149, 157, 165, 0.2)",
              transition: "transform 0.2s",
              "&:hover": { transform: "translateY(-4px)" },
            }}
        >
          <CardHeader
              title={
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Description
                </Typography>
              }
              sx={{
                bgcolor: theme.palette.primary.light,
                py: 1,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
              }}
          />
          <CardContent sx={{ bgcolor: "#f8f9fa", minHeight: 200 }}>

            <div key={'view'} className="row" style={{ padding: '8px 0',display:'flex',justifyContent:"space-evenly" }}>
              <div>
                Title
              </div> :
              <div >
                {data.title}
              </div>
            </div>



            <div key={'click'} className="row" style={{ padding: '8px 0',display:'flex',justifyContent:"space-evenly" }}>
              <div>
                Url
              </div> :
              <div >
                {data.pin_url}
              </div>
            </div>

          </CardContent>
        </Card>
        <Card
            sx={{
              minWidth: 300,
              maxWidth: 400,
              m: 2,
              borderRadius: 4,
              boxShadow: "0px 8px 24px rgba(149, 157, 165, 0.2)",
              transition: "transform 0.2s",
              "&:hover": { transform: "translateY(-4px)" },
            }}
        >
          <CardHeader
              title={
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Statistics Depend On Device Type
                </Typography>
              }
              sx={{
                bgcolor: theme.palette.primary.light,
                py: 1,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
              }}
          />
          <CardContent sx={{ bgcolor: "#f8f9fa", minHeight: 200 }}>
            {Object.entries(data?.device_percentages || {}).map(([deviceName, percentage]) => (
                <div key={deviceName} className="row" style={{ padding: '8px 0',display:'flex',justifyContent:"space-evenly" }}>
                  <div>
                    {deviceName.charAt(0).toUpperCase() + deviceName.slice(1)}
                  </div> :
                  <div >
                    {percentage}%
                  </div>
                </div>
            ))}

          </CardContent>
        </Card>
        <Card
            sx={{
              flex: "1 1 calc(33.33% - 32px)", // 33% width minus gap
              minWidth: 300,
              maxWidth: 'auto',
              borderRadius: 4,
              boxShadow: "0px 8px 24px rgba(149, 157, 165, 0.2)",
              transition: "transform 0.2s",
              "&:hover": { transform: "translateY(-4px)" },
            }}
        >
          <CardHeader
              title={
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  Statistics Depend On Country
                </Typography>
              }
              sx={{
                bgcolor: theme.palette.primary.light,
                py: 1,
                borderTopLeftRadius: 16,
                borderTopRightRadius: 16,
              }}
          />
          <CardContent sx={{ bgcolor: "#f8f9fa", minHeight: 200 }}>
            {(() => {
              const entries = Object.entries(data?.country_percentages || {});
              const chunkSize = 3;

              // Split entries into groups of 3
              const chunks = Array.from({ length: Math.ceil(entries.length / chunkSize) }, (_, i) =>
                  entries.slice(i * chunkSize, i * chunkSize + chunkSize)
              );

              return chunks.map((group, groupIndex) => (
                  <div
                      key={groupIndex}
                      style={{
                        display: 'flex',
                        borderBottom: '1px solid #e0e0e0', // Optional horizontal separator
                        '&:last-child': { borderBottom: 'none' }
                      }}
                  >
                    {group.map(([countryName, percentage], indexInGroup) => (
                        <div
                            key={countryName}
                            style={{
                              flex: 1,
                              padding: '8px 0',
                              display: 'flex',
                              justifyContent: 'space-evenly',
                              position: 'relative',
                              borderRight: indexInGroup < group.length - 1
                                  ? '1px solid #e0e0e0'
                                  : 'none', // Vertical separator
                            }}
                        >
                          <div>
                            {countryName !== ''
                                ? countryName.charAt(0).toUpperCase() + countryName.slice(1)
                                : 'Other'}
                          </div>
                          <div>
                            {percentage}%
                          </div>
                        </div>
                    ))}

                    {/* Fill remaining space if group has less than 3 items */}
                    {group.length < 3 && Array.from({ length: 3 - group.length }).map((_, i) => (
                        <div key={`empty-${i}`} style={{ flex: 1 }} />
                    ))}
                  </div>
              ));
            })()}
          </CardContent>
        </Card>
      </div>
  );
};
